/**
 * 
// 描边连接类型
export type StrokeLinejoin = 'miter' | 'round' | 'bevel';

// 描边端点类型
export type StrokeLinecap = 'butt' | 'round' | 'square';

// 主题
export type Theme = 'outline' | 'filled' | 'two-tone' | 'multi-color';
 * 
 */

const base = {
    size: 16,
    strokeWidth: 4,
    strokeLinecap: 'butt',
    strokeLinejoin: 'miter',
}

function initColors(
    theme, 
    customColor = ['#000000', '#000000', '#000000', '#000000'], 
    isCurrentColor = true) {
    const colors = Array(3).fill(customColor[0]);
    // 以下为留白逻辑
    // 线性
    if (theme === 'outline') {
        colors[0] = isCurrentColor ? 'currentColor' : customColor[0];
        colors[1] = '#ffffff';
        colors[2] = isCurrentColor ? 'currentColor' : customColor[0];
    }
    // 面性
    if (theme === 'filled') {
        colors[0] = isCurrentColor ? 'currentColor' : customColor[1];
        colors[1] = isCurrentColor ? 'currentColor' : customColor[1];
        colors[2] = '#ffffff';
    }
    // 双色
    if (theme === 'two-tone') {
        colors[0] = customColor[0];
        colors[1] = customColor[1];
        colors[2] = customColor[0];
    }
    // 多色
    if (theme === 'multi-color') {
        colors[0] = customColor[0];
        colors[1] = customColor[1];
        colors[2] = customColor[2];
    }
    return colors;
}

function initSize(size, isFontSize = false) {
    return isFontSize ? '1em' : `${size}px`;
}

export default {
    name: 'commonIconSave',
    cName: '保存',
    render(config) {
        const props = {
            ...base,
            ...config,
            size: initSize(config.size, config.isFontSize),
            colors: initColors(config.theme, config.colors, config.isCurrentColor)
        }
        return this.svgFn(props);
    },
    svgFn: (props) => (
        `
        <?xml version="1.0" encoding="UTF-8"?>
        <svg width="${props.size}" height="${props.size}" viewBox="0 0 48 48" version="1.1" xmlns="http://www.w3.org/2000/svg">
            <g stroke="none" fill="none" fill-rule="evenodd">
                <g transform="translate(6.000000, 6.000000)" >
                    <path d="M1,0 L26,0 L26,0 L36,10 L36,35 C36,35.5522847 35.5522847,36 35,36 L1,36 C0.44771525,36 6.76353751e-17,35.5522847 0,35 L0,1 C-6.76353751e-17,0.44771525 0.44771525,1.01453063e-16 1,0 Z" stroke="${props.colors[0]}" fill="${props.colors[1]}" stroke-linecap="round" stroke-linejoin="round" stroke-width="${props.strokeWidth}"></path>
                    <polyline stroke="${props.colors[2]}" fill="#FFFFFF" points="8 34 8 20 28 20 28 34" stroke-linejoin="round" stroke-width="${props.strokeWidth}"></polyline>
                    <polyline stroke="${props.colors[2]}" fill="#FFFFFF" points="21 2 21 8 8 8 8 2" stroke-linejoin="round" stroke-width="${props.strokeWidth}"></polyline>
                </g>
            </g>
        </svg>
        `
    )
};
